import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CONTEXT_HEADER, activeCustomer, needsContext } from '../services/customer-context';
/**
 * Rebillers (30 Oct 2026): the selected customer on the customer's own /account and /telecom requests (core/services/customer-context.ts).
 * 3 Nov 2026: the rule sees the query (urlWithParams) and the method, so a rebiller's Monthly invoices list (tab=monthly only) keeps it.
 */
export const customerContextInterceptor: HttpInterceptorFn = (req, next) => {
  const id = activeCustomer();
  return id && needsContext(req.urlWithParams, environment.apiBaseUrl, req.method) ? next(req.clone({ setHeaders: { [CONTEXT_HEADER]: id } })) : next(req);
};
